import { getLinkData } from '@/core/utils';
import { GetClassExhibitQuery, FeatureExhibitsInteractivesFragment, AcfMediaFragment } from '@graphqlTypes';

type Exhibit = GetClassExhibitQuery['classOfExhibit'] | FeatureExhibitsInteractivesFragment['exhibits'][number];
export type ExhibitData = {
  title: string;
  excerpt: string | null;
  uri?: string;
  mediaType: string;
  labelOverride?: string;
  linkTarget?: string;
  node?: Exhibit & {
    __typename: 'Exhibit';
  };
  image?: AcfMediaFragment
  videoUrl?: string | null;
  videoThumbnail?: AcfMediaFragment;
}

export const getExhibitData = (exhibit: Exhibit, labelOverride?: string): ExhibitData | undefined => {
  switch (exhibit?.__typename) {
    case "Exhibit": {
      const { exhibitData, title, uri } = exhibit;
      const { exhibitMedia: { mediaType, videoThumbnail, videoUrl, image }, excerpt } = exhibitData;
      return {
        title: exhibitData?.cardTitle || title,
        mediaType: mediaType[0],
        node: {
          ...exhibit,
          __typename: 'Exhibit',
        },
        excerpt,
        labelOverride,
        image,
        videoUrl,
        videoThumbnail,
        uri
      };
    }
    case "FeatureExhibitsInteractivesExhibits": {
      const { type, labelOverride } = exhibit;
      const isManual = type[0] === "manual";
      if (isManual) {
        const { headline, link, excerpt, mediaType, videoUrl, image, videoThumbnail, exhibitType } = exhibit.manualExhibit;
        const [type] = exhibitType || [];
        const linkData = getLinkData(link, true);
        let node;
        if (type === "exhibit") {
          node = { __typename: 'Exhibit' as const };
        } else if (type) {
          node = {
            __typename: "Exhibit" as const,
            exhibitTypes: { nodes: [{ slug: type }] }
          }
        }
        return {
          title: headline || '',
          mediaType: mediaType[0],
          uri: linkData?.url,
          linkTarget: linkData?.target,
          labelOverride,
          node,
          excerpt,
          image,
          videoUrl,
          videoThumbnail,
        }
      } else if (exhibit?.exhibit?.node && exhibit.exhibit.node.__typename === "Exhibit") {
        return getExhibitData(exhibit.exhibit.node, labelOverride);
      }
    }
    default: 
      return undefined;
  }
}